export default __webpack_public_path__ + "static/media/rando.9952a923.png";